// extracted by mini-css-extract-plugin
export default {"pageHeader":"Header_pageHeader__vof4E","pageHeaderTitle":"Header_pageHeaderTitle__pWSgB"};